import { Suspense } from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './institutions.admin.module.scss'

import { Loader } from '@/components/Loader'
import { LinkButton } from '../../../../components/LinkButton'
import { InstitutionsService } from '@/services/institutions'
import { useListInstitutions } from './@hooks/use-list-institutions'

const institutionsService = new InstitutionsService()

export function InstitutionsPage() {
  const navigate = useNavigate()
  const { institutions, isLoadingInstitutions } = useListInstitutions({
    institutionsService,
  })

  const openInstitutions = async (id: string) => navigate(`/institution/${id}`)

  return (
    <Suspense fallback={<Loader />}>
      <div className={styles.mainContainer}>
        <LinkButton
          link="/institution/adicionar"
          labelText="Adicionar Instituição"
        />

        {institutions &&
          institutions?.map((institution) => {
            return (
              <div
                onClick={() => openInstitutions(String(institution.id))}
                className={`${styles.unit} ${!institution.active ? styles.inactive : ''}`}
              >
                <p>{institution.id}</p>
                <p>{institution.active ? 'Ativa' : 'Inativa'}</p>
                <p>{institution.title}</p>
              </div>
            )
          })}

        {isLoadingInstitutions && <Loader />}
      </div>
    </Suspense>
  )
}
